import React, { useState } from 'react';

import { typography } from '@pray/shared/components/foundations';
import Text from '@pray/shared/components/ui/Text';
import { cn } from '@pray/shared/utils/styles';

import PaymentMethodWallet from 'components/pages/components/checkout/PaymentMethodWallet/PaymentMethodWallet';

import styles from './WalletPaymentButton.module.scss';

export default function WalletPaymentButton({
  amount,
  planName,
  disabled,
  onCheckoutReady,
  onCheckoutSuccess = () => {},
  onCheckoutFailure = () => {},
}) {
  const [isWalletPaymentAvailable, setWalletPaymentAvailable] = useState(null);

  if (isWalletPaymentAvailable === false) return null;

  const paymentLabel = `${planName} Plan Subscription`;

  return (
    <div className={cn(styles.wallet, { [styles.hidden]: !isWalletPaymentAvailable })}>
      <PaymentMethodWallet
        label={paymentLabel}
        amount={amount}
        disabled={disabled}
        onPaymentMethodLoad={(result) => setWalletPaymentAvailable(!!result)}
        onCheckoutReady={onCheckoutReady}
        onCheckoutSuccess={onCheckoutSuccess}
        onCheckoutFailure={onCheckoutFailure}
      />
      <Text variant={typography.heading_md} className={styles.payWithCardText}>
        Or pay with a card
      </Text>
    </div>
  );
}
